import { Color, Flex, Icon, Link, Spacing, Text } from '@billy/design-system'
import { useCallback } from 'react'

import { useSegment } from '../../../../../../../../hooks'
import { useTransactionDrawerContext } from '../../contexts/TransactionDrawerContext'
import * as Styled from './styles'

interface OriginatorLinkProps {
  text: string
  url?: string | null
}

export const OriginatorLink = ({ text, url }: OriginatorLinkProps) => {
  const { track } = useSegment()
  const { originatorType, transactionId } = useTransactionDrawerContext()

  const handleClick = useCallback(() => {
    if (url) {
      window.open(url, '_blank')
    }
    track('xxx - Bookkeeping - Ledger - Drawer', {
      action: 'Open origin',
      transactionId,
      transactionType: originatorType,
    })
  }, [originatorType, track, transactionId, url])

  return (
    <Styled.OriginatorLinkWrapper>
      <Link underlined={false} colorVariant="highlight" onClick={handleClick}>
        <Flex gap={Spacing.S4} alignItems="center">
          <Styled.LabelWrapper>
            <Text truncate color={Color.Lavender500}>
              {text}
            </Text>
          </Styled.LabelWrapper>
          <Styled.IconWrapper>
            <Icon color={Color.Lavender500} icon="squareArrowOutUpRight" />
          </Styled.IconWrapper>
        </Flex>
      </Link>
    </Styled.OriginatorLinkWrapper>
  )
}
